import NostoRecommendationsLists from './recommendation-lists';

// The recommendations should be loaded on every pages due to dynamic content
export default class NostoRecommendations {
  skipPageViews;
  NostoRecommendationsListsInstance;
  recommendationsData;

  constructor() {
    this.skipPageViews = false;
    this.NostoRecommendationsListsInstance = null;
    this.recommendationsData = null;

    if (!window.theme.api.nosto.recommendations.init) {
      this.init();
      window.theme.api.nosto.recommendations.init = true;
    }

    document.addEventListener('astr-nosto-recommendations-refresh', (e) => {
      if (typeof e.detail.data === 'undefined' || e.detail.data === null) {
        return;
      }

      this.recommendationsData = e.detail.data;
      this.cleanUpData();
      this.initLists(this.recommendationsData);
    });
  }

  init = (placement_name = '') => {
    // We don't request the no results recommendation data if it's already loaded; just init the list
    if (placement_name === window.theme.search.nosto_search_no_results_placement && window.theme.search.nosto_search_no_results) {
      this.initLists(window.theme.search.nosto_search_no_results, placement_name);
      return true;
    }

    // https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/recommendation-callbacks
    // nostojs(api => {  
    //   api.listen('prerender', event => {    
    //     console.log('prerender', event);
    //   });
    // });

    // https://jsdoc.nosto.com/RequestBuilder.html
    nostojs(api => {
      api
        .createRecommendationRequest({ includeTagging: true })
        .setResponseMode('JSON_ORIGINAL')
        // .addElements([])
        // .enablePreview() // remove once Nosto is on production mode
        .load({ skipPageViews: this.skipPageViews }) // if true, avoid counting as page view
        .then(response => {
          console.log('[ASTR] Nosto recommendations response', response);

          if (response.recommendations.length === 0) {
            return;
          }

          this.recommendationsData = response.recommendations;
          this.cleanUpData();
          this.initLists(this.recommendationsData, placement_name);
        });
    });

    return true;
  };

  /**
   * Clean up the recommendation data before initializing the lists as Nosto can return some out of stock variants
   * 
   * @returns {boolean}
   */
  cleanUpData = () => {
    for (const key in this.recommendationsData) {
      if (this.recommendationsData.hasOwnProperty(key)) {
        this.recommendationsData[key].products.forEach(product => {
          product.skus = product.skus.filter(sku => sku.available);
        });
      }
    }

    return true;
  };

  /**
   * 
   * @param {any} recommendations Nosto recommendations response object
   * @param {string} placement_name  Nosto placement name
   * @returns {boolean}
   */
  initLists = (recommendations, placement_name = '') => {
    // Init extra dynamic placements.
    // Only the "No search results" placement is dynamic for now.
    if (placement_name !== '') {
      const placement = document.getElementById(placement_name);

      if (placement === null) {
        return true;
      }

      // Save the no results data to avoid reloading it
      // We don't use the recommendation list product tiles for this placement
      if (placement_name === window.theme.search.nosto_search_no_results_placement) {
        window.theme.search.nosto_search_no_results = recommendations[placement_name];

        const event = new CustomEvent('astr-nosto-no-search-results-recommendations-loaded', { 
          detail: {
            message: 'Nosto no search results recommendations have been loaded',
            data: recommendations[placement_name],
          }
        });

        document.dispatchEvent(event);

        return true;
      }
    }
   
    if (this.NostoRecommendationsListsInstance === null) {
      this.NostoRecommendationsListsInstance = new NostoRecommendationsLists();
    }

    this.NostoRecommendationsListsInstance.setRecommendationData(recommendations);
    this.NostoRecommendationsListsInstance.init();

    // this.NostoRecommendationsListsInstance.setRecommendationData(recommendations);
    // this.NostoRecommendationsListsInstance.initDynamicSection(placement);

    return true;
  };

  /**
   * Load a specific Nosto recommendation placement
   * 
   * @param {string} placement_name Nosto placement name
   * @returns {boolean}
   */
  loadDynamicRecommendation = (placement_name) => {
    this.skipPageViews = true;
    
    this.init(placement_name);
    // nostojs(api => {
    //   api.loadRecommendations();
    // });

    return true;
  };
}
